<template>
  <div class="container auth-page">

    <div class="row">
      <div class="col-xs-12 col-md-12 ">
        <div class="panel panel-default">
          <div class="panel-heading"><strong>Update Credit Card Details</strong></div>
          <div class="panel-body">

            <div class="row" v-if="user">
              <div class="col-md-12">
                <h3>Your Details:</h3>
                Signed in as: {{ user.first_name }} ({{ user.email }})
              </div>
            </div>

            <div class="cell form-wrapper">
              <div class="payment-form-wrapper">
                <h3>Update your billing details:</h3>
                <coupon @couponSubmit="setCoupon($event)" v-if="this.mode !== 'update'" :current-coupon="this.currentCoupon"></coupon>
                <div class="radio-wrapper">
                  <div class="radio">
                    <input id="radio-2" name="payment-type" type="radio" @click="setPaymentType('basc_payment')" checked>
                    <label for="radio-2" class="radio-label">Pay By Direct Debit</label>
                    <div class="bacs-description" v-if="paymentType ==='basc_payment'">Bank details will collected after you click submit</div>
                  </div>

                  <div class="radio">
                    <input id="radio-1" name="payment-type" type="radio" @click="setPaymentType('credit_card')">
                    <label for="radio-1" class="radio-label">Pay By Credit or Debit Card</label>
                  </div>
                </div>

                <div id="card" v-show="paymentType ==='credit_card'">
                  <div class="cell example payment" id="payment">
                    <div class="row">
                      <div class="field">
                        <div id="payment-card-number" ref="card_number" class="input empty"></div>
                        <label for="payment-card-number" data-tid="elements_payment.form.card_number_label">Card number</label>
                        <div class="baseline"></div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="field half-width">
                        <div id="payment-card-expiry" ref="card_expiry" class="input empty"></div>
                        <label for="payment-card-expiry" data-tid="elements_payment.form.card_expiry_label">Expiration</label>
                        <div class="baseline"></div>
                      </div>
                      <div class="field half-width">
                        <div id="payment-card-cvc" ref="card_cvc" class="input empty"></div>
                        <label for="payment-card-cvc" data-tid="elements_payment.form.card_cvc_label">CVC</label>
                        <div class="baseline"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="debit" v-show="paymentType ==='basc_payment'">
                </div>

                <button type="submit" class="btn btn-primary submit" @click="upgrade">
                  <span v-if="isLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                  <span v-else>
                    Submit
                  </span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { loadStripe } from '@stripe/stripe-js'

export default {
  name: "PaymentUpdate",
  props: ['currentCoupon'],
  data() {
    return {
      user: null,
      stripe: {},
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},
      paymentMethod: null,
      elements: null,
      paymentType: 'basc_payment',
      coupon:null,
      mode:null,
      isLoading: false,
    }
  },
  methods: {
    setCoupon(coupon) {
      this.coupon = coupon
    },
    upgrade() {
      this.isLoading = true;
      let upgradeData = {
        payment_method: this.paymentMethod ? this.paymentMethod.id : null,
        payment_type: this.paymentType,
        user_id: this.user.id,
        coupon:this.coupon
      }

      if (this.paymentType === 'credit_card') {
        if (this.checkCard()) {
          this.getPaymentMethod()
              .then(() => {
                upgradeData.payment_method = this.paymentMethod
                this.runUpgrade(upgradeData)
              })
        }
      } else if (this.paymentType === 'basc_payment') {
        this.runUpgrade(upgradeData)
      }
      console.log(1)
    },
    getPaymentMethod() {
      return this.stripe.createPaymentMethod({
        type: 'card',
        card: this.cardNumber,
        billing_details: {
          name: this.user.first_name + ' ' + this.user.last_name,
        },
      }).then((result) => {
        this.paymentMethod = result.paymentMethod
      })
    },
    runUpgrade(upgradeData) {
      axios.post('/payment-update/' + this.user.id, upgradeData).then((res) => {
        if (this.paymentType === 'basc_payment') {
          this.stripe.redirectToCheckout({
            sessionId: res.data.id
          }).then(function (res) {
            console.log("res", res)
          })
        } else if (this.paymentType === 'credit_card') {
          window.location.href = '/dashboard'
        }
      }).catch((error) => {
        console.log('error', error)
      })
    },
    setPaymentType(value) {
      this.paymentType = value
    },
    getUser() {
      axios.get('/user').then((res) => {
        this.user = res.data
      }).catch((error) => {
        console.log('error', error)
      })
    },
    checkCard() {
      if (!this.$refs.card_number.classList.contains('StripeElement--complete')) {
        this.$refs.card_number.classList.add('invalid')
      }
      if (!this.$refs.card_expiry.classList.contains('StripeElement--complete')) {
        this.$refs.card_expiry.classList.add('invalid')
      }
      if (!this.$refs.card_cvc.classList.contains('StripeElement--complete')) {
        this.$refs.card_cvc.classList.add('invalid')
      } else {
        return true
      }

      return false
    }
  },
  created() {
    this.mode = new URL(location.href).searchParams.get("mode");
    this.getUser()
  },
  mounted() {
    if (this.type !== 'lite' && this.type !== 'financial-ratios') {
      loadStripe(process.env.MIX_STRIPE_KEY).then((stripe) => {
        this.stripe = stripe
        this.elements = this.stripe.elements()

        var elementStyles = {
          base: {
            color: '#32325D',
            fontWeight: 500,
            fontFamily: 'museo-sans-rounded, Source Code Pro, Menlo, monospace',
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#CFD7DF',
            },
            ':-webkit-autofill': {
              color: '#e39f48',
            },
          },
          invalid: {
            color: '#E25950',

            '::placeholder': {
              color: '#FFCCA5',
            },
          },
        }

        var elementClasses = {
          focus: 'focused',
          empty: 'empty',
          invalid: 'invalid',
        }

        this.cardNumber = this.elements.create('cardNumber', {
          style: elementStyles,
          classes: elementClasses,
        })
        this.cardNumber.mount('#payment-card-number')

        this.cardExpiry = this.elements.create('cardExpiry', {
          style: elementStyles,
          classes: elementClasses,
        })
        this.cardExpiry.mount('#payment-card-expiry')

        this.cardCvc = this.elements.create('cardCvc', {
          style: elementStyles,
          classes: elementClasses,
        })
        this.cardCvc.mount('#payment-card-cvc')
      })
    }
  }
}
</script>
<style scoped>

</style>
